<!--  -->
<template>
  <div class="HeadNav">
    <div class="NavMain">
      <div class="navlogo">
        <router-link to="/">
          <img src="../assets/NavLogo.png" />
        </router-link>
      </div>
      <ul class="navlist">
        <li v-for="(item, key) in navlist" :key="key" class="centern">
          <router-link :to="item.url">
            {{ item.title }}
          </router-link>
        </li>
        <li v-if="isshow == 1">
          <el-select @change="selectl" v-model="value" :placeholder="qxz">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </li>
      </ul>
      <div class="Navbottom"></div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据:首页
    return {
      isshow: 0, //是否显示语言选择0否(国外),1是(中国)
      navlist: [
        /* 
        {
          title: "首页1",
          url: "/index",
        },
        {
          title: "关于堃博",
          url: "/aboutUs",
        },
        {
          title: "产品&临床应用",
          url: "/product",
        },
        {
          title: "新闻中心",
          url: "/news",
        },
        {
          title: "招贤纳士",
          url: "/joinUs",
        },
        {
          title: "投资者关系",
          url: "/investor",
        },
       */
      ],
      options: [
        {
          value: "1",
          label: "En",
        },
        {
          value: "0",
          label: "简",
        },
        {
          value: "6",
          label: "繁",
        },
      ],
      value: "0",
      qxz: "", //请选择
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //1.头部导航
    get_nav() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_nav",
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            if (obj.region) {
              if (parseInt(obj.region) > 0) that.isshow = 0;
              else that.isshow = 1;
            } else {
              that.isshow = 1;
            }
            console.log("头部导航:"+that.isshow);
            
            $.each(obj.data, function (i, k) {
              that.navlist.push({
                title: k.title,
                url: k.url,
              });
            });
            that.value = obj.lang ? obj.lang : "0";
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //2.选择语言
    selectl(value) {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "post",
        datatype: "json",
        data: {
          act: "save_biaoshi",
          lang: value,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            //得到当前url
            var url = window.location.href;
            if (url.match(/lungcancer6/)) {
              url = url.replace("lungcancer6", "lungcancer" + value);
              location.href = url;
            } else if (url.match(/lungcancer1/)) {
              url = url.replace("lungcancer1", "lungcancer" + value);
              location.href = url;
            } else if (url.match(/lungcancer/)) {
              url = url.replace("lungcancer", "lungcancer" + value);
              location.href = url;
            } else location.reload();
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //3.文字翻译
    get_fanyi() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_fanyi",
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.qxz = obj.data["qxz"];
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.get_nav();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../scss/public.scss";
.HeadNav {
  position: absolute;
  z-index: 99;
  width: 100%;
  height: 120px;
  .NavMain {
    width: 94%;
    margin: 0 auto;
    padding: 22px 0;
    position: relative;
    display: flex;
    justify-content: space-between;
    .navlogo {
      width: 220px;
      height: 73px;
      display: inline-block;
      img {
        width: 100%;
        height: auto;
      }
    }
    .navlist {
      display: flex;
      justify-content: space-between;
      li {
        margin-top: 30px;
        width: auto;
        color: #2d2d2d;
        padding: 0 20px;
        font-size: 1.2rem;
        display: flex;
        align-items: center;
        a {
          text-align: center;
          display: flex;
          justify-content: center;
          transition: 0.3s;
          font-weight: 600;
        }
         .router-link-active {
          color: #302b7f;
        }
       
      }
      li >>> .el-input__inner {
        width: 50px;
        height: 25px;
        border: 1px solid #000;
        background-color: rgba(0, 0, 0, 0);
        border-radius: 20px;
        color: #000;
        padding: 8px;
      }
      li >>> .el-input__inner::-webkit-input-placeholder {
        color: #2d2d2d;
      }
      li >>> .el-input__suffix {
        top: 0px;
      }
      li >>> .el-input__icon {
        line-height: 0;
      }
      li:hover a {
        color: #302b7f;
      }
    }
    .Navbottom {
      position: absolute;
      bottom: -10px;
      width: 100%;
      height: 10px;
      background: linear-gradient(90deg, #ffdf00, #d0b501);
    }
  }
}
@media screen and (max-width: 1500px) {
  .HeadNav {
    .NavMain {
      .navlist {
        li {
          padding: 0 15px;
        }
      }
    }
  }
}
@media screen and (max-width: $main-width) {
  .HeadNav {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Nav.vue